import axiosInstance from "../lib/axiosInstance";
import axiosInstanceNew from "../lib/axiosinstanceNew";

const ClassModal = class {
  constructor() {
    this.baseUrl = "/adminapi/c-class/";
    this.staticData = [
      {
        id: 1,
        parent_id: 101,
        name: "Mathematics Class - Grade 8",
        status: "Active",
        tutorApi_tutor: {
          auth_user: {
            first_name: "Rajesh",
            last_name: "Kumar",
          },
        },
        subjectNames: ["Mathematics", "Geometry"],
        student_data: [
          { name: "Amit Sharma" },
          { name: "Priya Patel" },
          { name: "Rohit Verma" },
        ],
        adminApi_classcycle: {
          class_id_id: 201,
          total_duration: 120,
          remaining_duration: 85,
          student_recovery: 10,
          remaining_student_recovery: 5,
          parent_fees_status: "Paid",
        },
      },
      {
        id: 2,
        parent_id: 102,
        name: "Science Class - Grade 9",
        status: "Active",
        tutorApi_tutor: {
          auth_user: {
            first_name: "Priya",
            last_name: "Singh",
          },
        },
        subjectNames: ["Physics", "Chemistry", "Biology"],
        student_data: [{ name: "Sneha Gupta" }, { name: "Vikram Patel" }],
        adminApi_classcycle: {
          class_id_id: 202,
          total_duration: 180,
          remaining_duration: 120,
          student_recovery: 15,
          remaining_student_recovery: 10,
          parent_fees_status: "Pending",
        },
      },
      {
        id: 3,
        parent_id: 103,
        name: "English Literature - Grade 7",
        status: "Active",
        tutorApi_tutor: {
          auth_user: {
            first_name: "Amit",
            last_name: "Verma",
          },
        },
        subjectNames: ["English", "Literature"],
        student_data: [
          { name: "Rahul Kumar" },
          { name: "Anjali Sharma" },
          { name: "Karan Singh" },
          { name: "Meera Joshi" },
        ],
        adminApi_classcycle: {
          class_id_id: 203,
          total_duration: 90,
          remaining_duration: 45,
          student_recovery: 5,
          remaining_student_recovery: 2,
          parent_fees_status: "Paid",
        },
      },
      {
        id: 4,
        parent_id: 104,
        name: "Hindi Class - Grade 6",
        status: "Inactive",
        tutorApi_tutor: {
          auth_user: {
            first_name: "Sunita",
            last_name: "Gupta",
          },
        },
        subjectNames: ["Hindi", "Sanskrit"],
        student_data: [{ name: "Arjun Reddy" }, { name: "Pooja Nair" }],
        adminApi_classcycle: {
          class_id_id: 204,
          total_duration: 100,
          remaining_duration: 20,
          student_recovery: 8,
          remaining_student_recovery: 3,
          parent_fees_status: "Overdue",
        },
      },
      {
        id: 5,
        parent_id: 105,
        name: "Social Studies - Grade 10",
        status: "Active",
        tutorApi_tutor: {
          auth_user: {
            first_name: "Vikram",
            last_name: "Patel",
          },
        },
        subjectNames: ["History", "Geography", "Civics"],
        student_data: [
          { name: "Deepak Sharma" },
          { name: "Kavita Singh" },
          { name: "Ravi Kumar" },
        ],
        adminApi_classcycle: {
          class_id_id: 205,
          total_duration: 150,
          remaining_duration: 95,
          student_recovery: 12,
          remaining_student_recovery: 8,
          parent_fees_status: "Paid",
        },
      },
    ];
  }

  async classListss() {
    return await axiosInstance.get(`${this.baseUrl}`);
  }
  async listClass(query = []) {
    return (
      await axiosInstance.get(`${this.baseUrl}?${new URLSearchParams(query)}`)
    ).data;
  }
  async listClassNew(query = []) {
    // Return static attendance data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: this.staticData,
          meta: {
            current_page: 1,
            per_page: 20,
            total_page: 1,
            total: this.staticData.length,
          },
        });
      }, 500);
    });
  }
  async listClassNewfilter(query = []) {
    // Return filtered data for due classes (classes with pending/overdue payments)
    return new Promise((resolve) => {
      setTimeout(() => {
        const filteredData = this.staticData.filter(
          (item) =>
            item.adminApi_classcycle?.parent_fees_status === "Pending" ||
            item.adminApi_classcycle?.parent_fees_status === "Overdue"
        );
        resolve({
          data: filteredData,
          meta: {
            current_page: 1,
            per_page: 20,
            total_page: 1,
            total: filteredData.length,
          },
        });
      }, 500);
    });
  }
  /* async createClass(data =[]) {
        return (await axiosInstance.post(`/adminapi/c-class/`,data)).data;
    } */

  async createClass(data) {
    console.log(data, "classmodal");
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const jsonData = JSON.stringify(data);
      const response = await axiosInstance.post(this.baseUrl, jsonData, {
        headers,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating class:", error);
      throw error; // Rethrow the error for handling at the calling site
    }
  }

  async editClass(data) {
    console.log(data, "classmodal");
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const jsonData = JSON.stringify(data);
      const response = await axiosInstance.put(this.baseUrl, jsonData, {
        headers,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating class:", error);
      throw error; // Rethrow the error for handling at the calling site
    }
  }

  async deleteclass(data = {}) {
    return await axiosInstance.delete(`${this.baseUrl}?id=${data}`);
  }
  async listbyClassid(id = {}) {
    return await axiosInstance.get(`${this.baseUrl}?id=${id}`);
  }

  async studentListByClass(classId) {
    return (await axiosInstanceNew.get(`class/student/${classId}`)).data;
  }
};

export default new ClassModal();
